<div class="main" [style.width]="col.columnWidth ? (col.columnWidth + 'px') : '100%'">
    <div class="picker-container">
        <div #el class="picker-items"></div>
    </div>
</div>
